'use client';

import type React from 'react';
import utilsStyles from '../../../styles/modules/utils.module.scss';
import styles from './UrlShare.module.scss';

export type UrlShareProps = {
  url: string;
  twitterShareText: string;
  onCopySuccess?: (url: string) => void;
  shareText?: string;
};

function UrlShare({ url, twitterShareText, onCopySuccess, shareText = 'シェアする' }: UrlShareProps) {
  const currentStyles = styles;

  const copyLink = async (e: React.MouseEvent) => {
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(url);
      onCopySuccess?.(url);
    } catch (error) {
      console.error('Failed to copy URL:', error);
    }
  };

  return (
    <div className={currentStyles.urlShare} data-testid='url-share'>
      <p className={`${currentStyles.shareLabel} ${utilsStyles.textBold}`}>{shareText}</p>
      <ul className={currentStyles.shareList}>
        <li>
          {/* Twitter */}
          <a
            href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
              twitterShareText,
            )}%20${encodeURIComponent(url)}`}
            className={`${currentStyles.shareLink} ${currentStyles.shareLinkTwitter}`}
            rel='noreferrer nofollow'
            target='_blank'
          >
            <img src='/images/sns/btn-twitter.png' alt='Twitter' />
          </a>
        </li>
        <li>
          {/* Line */}
          <a
            href={`https://timeline.line.me/social-plugin/share?url=${url}`}
            className={`${currentStyles.shareLink} ${currentStyles.shareLinkLine}`}
            rel='noreferrer nofollow'
            target='_blank'
          >
            <img src='/images/sns/btn-line.png' alt='line' />
          </a>
        </li>
        <li>
          {/* フェイスブック */}
          <a
            href={`http://www.facebook.com/share.php?u=${url}`}
            className={`${currentStyles.shareLink} ${currentStyles.shareLinkFacebook}`}
            rel='noreferrer nofollow'
            target='_blank'
          >
            <img src='/images/sns/btn-facebook.png' alt='Facebook' />
          </a>
        </li>
        <li>
          {/* コピー */}
          {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
          <a
            href='#'
            onClick={(e) => copyLink(e)}
            className={`${currentStyles.shareLink} ${currentStyles.shareLinkCopy}`}
            rel='noreferrer nofollow'
          >
            <img src='/images/sns/btn-link.png' alt='Copy' />
          </a>
        </li>
      </ul>
    </div>
  );
}

export default UrlShare;
